import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseApi } from '../components/api';

export interface AuthState {
    loading: boolean;
    error: string | null;
    success: boolean;
    userName: string;
    userType: 'Admin' | 'User' | 'public';
    authCode: number;
    token: string;
}

const initialState: AuthState = {
    loading: false,
    error: null,
    success: false,
    userName: '',
    userType: 'public',
    authCode: 0,
    token: '',
};

// Async thunk for login
export const loginAdmin = createAsyncThunk(
    'auth/loginAdmin',
    async (credentials: { email: string; password: string }, { rejectWithValue }) => {
        try {
            const response = await axios.post(baseApi + '/auth/login', credentials); // Replace with your API endpoint
            const { data } = response.data;
            localStorage.setItem('authData', JSON.stringify(data)); // Save to localStorage for persistence
            return data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.data || 'Login failed');
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState:{
        loading: false,
        error: null,
        success: false,
        userName: '',
        userType: 'public',
        authCode: 0,
        token: '',
    } as AuthState,
    reducers: {
        resetState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.userName = '';
            state.userType = 'public';
            state.authCode = 0;
            state.token = '';
            // Clear localStorage
            localStorage.removeItem('authData');
        },
        loadAuthFromStorage: (state) => {
            const storedAuth = localStorage.getItem('authData');
            if (storedAuth != null && storedAuth != undefined) {
                const parsedAuth = JSON.parse(storedAuth);
                state.userName = parsedAuth.userName;
                state.userType = parsedAuth.userType;
                state.authCode = parsedAuth.authCode;
                state.token = parsedAuth.token;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAdmin.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(loginAdmin.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.success = true;
                state.userName = action.payload.userName;
                state.userType = action.payload.userType;
                state.authCode = action.payload.authCode;
                state.token = action.payload.token;
            })
            .addCase(loginAdmin.rejected, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.error = action.payload || 'Login failed';
            })
    },
});

export const { resetState, loadAuthFromStorage } = authSlice.actions;

export default authSlice.reducer;
